import React from 'react';
import { Text } from '@doda/io-react/common';

import { ApplyButton } from '../../../../ApplyButton';
import styles from './index.module.scss';

/**
 * FooterAgentButtonのProps
 */
interface Props {
  handleApply: () => void;
  wcnsId: string;
  jobOfferKind: string;
  applyButtonChangeAbTestGroupNo?: string;
}

/**
 * 求人詳細ボディーの下部
 */
export const FooterAgentButton: React.FC<Props> = ({
  handleApply,
  wcnsId,
  jobOfferKind,
  applyButtonChangeAbTestGroupNo,
}) => {
  const isManuscriptT = wcnsId === 'T';

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault();
    const { href } = event.currentTarget;
    const windowFeatures = 'popup,width=782,height=426,';
    window.open(href, 'helpWindow', windowFeatures);
  };

  return (
    <>
      <section>
        <div className={styles['jobSearchDetail-footerApplyArea']}>
          <ApplyButton
            size="L"
            width={360}
            jobOfferKind={jobOfferKind}
            onClick={handleApply}
            abTestGroupNo={applyButtonChangeAbTestGroupNo}
          />
          <div
            className={styles['jobSearchDetail-footerApplyArea__button-text']}
          >
            <Text
              color="blue"
              size="14--articlePC"
              as="a"
              href="/info/help/about_agent.html"
              weight="normal"
              onClick={handleClick}
            >
              「エージェントサービス」とは？
            </Text>
            <div className={styles['jobSearchDetail-footerApplyArea__freeTag']}>
              <Text
                as="span"
                color="gray"
                size="11"
                weight="normal"
                className={
                  styles['jobSearchDetail-footerApplyArea__freeTag-box']
                }
              >
                完全無料
              </Text>
            </div>
            <div
              className={
                styles['jobSearchDetail-footerApplyArea__tag-annotation']
              }
            >
              <Text as="span" color="lightGray" size="11">
                ※1
              </Text>
              {isManuscriptT && (
                <Text as="span" color="lightGray" size="11">
                  ※2
                </Text>
              )}
            </div>
          </div>
        </div>
        <div className={styles['jobSearchDetail-footerApplyArea__noticetext']}>
          <Text color="gray" size="11" weight="normal">
            {NOTICE_TEXT.TEXT1}
            {isManuscriptT && (
              <>
                <br />
                {NOTICE_TEXT.TEXT2}
              </>
            )}
          </Text>
        </div>
      </section>
    </>
  );
};

/**
 * noticeの固定説明文
 */
const NOTICE_TEXT = {
  TEXT1:
    '※1.本案件以外にご紹介できる求人がご用意できない場合には、求人発生時までカウンセリングをお待ちいただいております。予めご了承ください。',
  TEXT2:
    '※2.本案件に記載されている内容は、雇用主との労働契約締結時の労働条件等と異なる可能性がございます。',
};
